var _g, _g2, _rect, _circle, _circle2, _g3, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555,
    height: 937,
    viewBox: "0 0 555 937",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.421,
    y: 282.39,
    width: 550,
    height: 340,
    rx: 20,
    transform: "rotate(16.4747 112.421 282.39)",
    fill: "#828282"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.265,
    y: 270.842,
    width: 550,
    height: 340,
    rx: 20,
    transform: "rotate(16.4747 126.265 270.842)",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.811,
    y: 279.743,
    width: 549,
    height: 339,
    rx: 19.5,
    transform: "rotate(16.4747 115.811 279.743)",
    fill: "#1F1F1F",
    stroke: "url(#paint0_linear_1_630)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 515.683,
    cy: 562.651,
    r: 27,
    transform: "rotate(15.1592 515.683 562.651)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.5,
    cy: 571.542,
    r: 27,
    transform: "rotate(15.1592 548.5 571.542)",
    fill: "#5D5D5D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.591 466.63C233.944 467.326 235.593 468.647 236.535 470.592C237.505 472.546 237.61 474.809 236.849 477.382L233.109 490.026L227.813 488.46L231.444 476.185C231.808 474.953 231.79 473.906 231.39 473.044C230.99 472.182 230.243 471.589 229.148 471.265C227.944 470.909 226.883 471.027 225.964 471.618C225.072 472.217 224.404 473.27 223.959 474.775L220.547 486.311L215.251 484.745L218.881 472.47C219.245 471.238 219.228 470.191 218.828 469.329C218.428 468.467 217.681 467.874 216.586 467.55C215.409 467.202 214.348 467.319 213.401 467.903C212.482 468.494 211.8 469.542 211.355 471.048L207.944 482.584L202.648 481.018L208.718 460.491L214.014 462.057L213.371 464.233C215.144 462.763 217.318 462.409 219.89 463.17C222.408 463.914 223.978 465.45 224.6 467.777C226.551 466.211 228.881 465.829 231.591 466.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.755 462.109C192.593 462.657 192.815 463.214 193.422 463.78C194.064 464.327 194.864 464.891 195.823 465.472C196.79 466.026 197.733 466.662 198.652 467.38C199.578 468.071 200.26 468.987 200.696 470.128C201.16 471.277 201.186 472.549 200.773 473.945C200.15 476.053 198.874 477.446 196.947 478.126C195.055 478.787 192.932 478.769 190.579 478.073C186.364 476.827 183.972 474.349 183.402 470.638L188.765 469.412C188.841 471.369 189.919 472.655 191.999 473.27C193.888 473.829 195.006 473.519 195.354 472.343C195.516 471.795 195.276 471.248 194.634 470.701C194.027 470.135 193.245 469.561 192.286 468.98C191.327 468.398 190.388 467.749 189.469 467.031C188.551 466.313 187.851 465.406 187.371 464.312C186.927 463.198 186.903 461.971 187.299 460.63C187.898 458.605 189.107 457.236 190.925 456.523C192.778 455.792 194.813 455.754 197.03 456.409C198.7 456.903 200.105 457.735 201.247 458.906C202.397 460.05 203.162 461.437 203.543 463.068L198.299 464.195C198.055 462.605 197.166 461.584 195.634 461.13C194.95 460.928 194.33 460.909 193.776 461.072C193.249 461.244 192.909 461.589 192.755 462.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.789 470.898C175.067 472.355 172.186 472.634 169.148 471.736C166.11 470.837 163.845 469.036 162.353 466.333C160.896 463.611 160.617 460.73 161.515 457.692C162.414 454.654 164.211 452.403 166.906 450.938C169.636 449.454 172.521 449.161 175.559 450.059C178.597 450.958 180.858 452.772 182.342 455.503C183.834 458.206 184.131 461.077 183.233 464.115C182.334 467.153 180.52 469.414 177.789 470.898ZM167.169 463.784C167.921 465.167 169.091 466.094 170.678 466.563C172.265 467.032 173.751 466.891 175.134 466.14C176.517 465.388 177.451 464.191 177.937 462.549C178.422 460.907 178.289 459.394 177.538 458.011C176.786 456.628 175.616 455.702 174.029 455.232C172.442 454.763 170.956 454.904 169.573 455.656C168.218 456.415 167.297 457.616 166.811 459.259C166.326 460.901 166.445 462.409 167.169 463.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.346 467.916L152.188 466.095L147.473 454.566L144.717 463.885L139.421 462.319L147.919 433.582L153.215 435.148L148.116 452.39L157.848 445.447L164.171 447.317L152.92 455.016L158.346 467.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.782 482.752C261.935 484.196 261.786 485.683 261.333 487.212C260.435 490.25 258.62 492.511 255.89 493.995C253.167 495.452 250.287 495.731 247.249 494.833C244.211 493.934 241.946 492.133 240.454 489.43C238.997 486.708 238.718 483.827 239.616 480.789C240.515 477.751 242.311 475.5 245.007 474.035C247.737 472.551 250.622 472.258 253.659 473.156C254.391 473.373 255.078 473.643 255.72 473.965C254.494 474.619 253.521 475.745 253.096 477.182C252.957 477.653 252.885 478.128 252.875 478.596C252.638 478.495 252.389 478.406 252.13 478.329C250.542 477.86 249.057 478.001 247.674 478.753C246.318 479.512 245.398 480.713 244.912 482.356C244.426 483.998 244.546 485.506 245.27 486.881C246.022 488.264 247.191 489.191 248.779 489.66C250.366 490.129 251.851 489.988 253.235 489.237C254.618 488.485 255.552 487.288 256.038 485.646C256.233 484.983 256.329 484.342 256.323 483.722C256.454 483.772 256.587 483.817 256.724 483.857C258.553 484.398 260.443 483.92 261.782 482.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.813 479.761C261.231 481.73 259.162 482.855 257.192 482.272C255.223 481.69 254.098 479.621 254.681 477.651C255.263 475.682 257.332 474.557 259.302 475.14C261.271 475.722 262.396 477.791 261.813 479.761Z",
    fill: "#7249F5"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 119.967,
    y: 521.34,
    width: 64,
    height: 42.6667,
    rx: 9.69697,
    transform: "rotate(16.4747 119.967 521.34)",
    fill: "url(#paint1_radial_1_630)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.533 530.822L140.551 539.498C140.551 539.498 140.512 549.661 135.413 556.873L138.675 570.919L149.051 560.907C149.051 560.907 148.3 553.417 154.19 543.531C154.19 543.531 150.533 530.822 150.533 530.822Z",
    stroke: "#C7C7B6",
    strokeWidth: 2.52121,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.539 532.931L140.406 539.989",
    stroke: "#C7C7B6",
    strokeWidth: 2.52121,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.362 543.821L177.911 551.081",
    stroke: "#C7C7B6",
    strokeWidth: 2.52121,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.699 549.296L135.566 556.355",
    stroke: "#C7C7B6",
    strokeWidth: 2.52121,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.522 560.186L173.071 567.446",
    stroke: "#C7C7B6",
    strokeWidth: 2.52121,
    strokeLinejoin: "bevel"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 350.644,
    y: -33,
    width: 550,
    height: 340,
    rx: 20,
    transform: "rotate(16.4747 350.644 -33)",
    fill: "#E9E9E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142.771,
    y: 669.907,
    width: 550,
    height: 340,
    rx: 20,
    transform: "rotate(16.4747 142.771 669.907)",
    fill: "#C3C3C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_630",
    x: 0.84552,
    y: 267.236,
    width: 654.15,
    height: 512.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1_630"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_630",
    x: 14.6888,
    y: 255.688,
    width: 654.15,
    height: 512.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1_630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_630",
    x1: 155.745,
    y1: 669.089,
    x2: 539.28,
    y2: 261.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.719 536.882) rotate(141.302) scale(43.3842 43.0552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDCDA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.802,
    height: 50,
    fill: "white",
    transform: "translate(141.222 421.259) rotate(16.4747)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDesktop);
export default __webpack_public_path__ + "static/media/bg-desktop.bd99afb818409b1d72ae2f11098ad726.svg";
export { ForwardRef as ReactComponent };